<div class="dialog-header">
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form
  style="margin-top: 40px; width: 100%"
  [formGroup]="form"
  (ngSubmit)="submitForm()"
>
  <h3 style="text-align: center">Orden de Compra</h3>
  <article class="form_purchase">
    <section class="container-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Código</mat-label>
        <input matInput formControlName="code" />
        <mat-hint
          *ngIf="f['code'].touched && f['code'].invalid"
          class="error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['code'].errors && f['code'].errors['required']"
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Monto</mat-label>
        <input matInput formControlName="amount"       
        mask="separator"
        thousandSeparator="."/>
        <mat-hint
          *ngIf="f['amount'].touched && f['amount'].invalid"
          class="error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['amount'].errors && f['amount'].errors['required']"
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Fecha Emisión</mat-label>
        <input type="date" matInput formControlName="fechaEmision" />
        <mat-hint
          *ngIf="f['fechaEmision'].touched && f['fechaEmision'].invalid"
          class="error-msg"
        >
          <div
            class="text-error"
            *ngIf="
              f['fechaEmision'].errors && f['fechaEmision'].errors['required']
            "
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Plazo</mat-label>
        <input matInput formControlName="plazo" />
        <mat-hint
          *ngIf="f['plazo'].touched && f['plazo'].invalid"
          class="error-msg"
        >
          <div
            class="text-error"
            *ngIf="f['plazo'].errors && f['plazo'].errors['required']"
          >
            Este Campo es requerido
          </div>
        </mat-hint>
      </mat-form-field>
      <mat-checkbox formControlName="sigfe" class="w-100"> Sigfe </mat-checkbox>
    </section>
    <section>
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: centers;
          gap: 1rem;
        "
      >
        <h4>Archivo Adjunto</h4>
        <input
          class="py-2"
          #inputFile
          type="file"
          (change)="onFileSelected($event)"
          id="file"
        />
        <a *ngIf="documentUri" mat-raised-button [href]="documentUri">
          <fa-icon [icon]="icons.faEye"></fa-icon>
          Ver adjunto
        </a>
      </div>
      <span *ngIf="validate">El archivo tiene que ser formato pdf</span>
    </section>
  </article>

  <ng-template #loading>
    <mat-spinner [diameter]="40"></mat-spinner>
  </ng-template>

  <div class="d-flex justify-content-end footer">
    <button type="button" (click)="closeDialog()" mat-flat-button>
      Cerrar
    </button>
    <ng-container *ngIf="!isLoading; else loading">
      <button
        mat-flat-button
        color="primary"
        [disabled]="!form.valid"
        class="w-50"
        type="submit"
      >
        {{ hasBuyOrder ? "Editar" : "Registrar" }}
      </button>
    </ng-container>
  </div>
</form>
